import { CONNECTION_CATEGORY_FILE } from 'js/constants/connectionCategories';

export function createResourceSetupService() {
  function canEditPrefix({ connectionCategory, selectedBucket, sinkConfig }) {
    return (
      connectionCategory === CONNECTION_CATEGORY_FILE &&
      selectedBucket &&
      selectedBucket?.path &&
      sinkConfig?.['ui.selected_file_mime_type'] !== 'application/vnd.google-apps.spreadsheet'
    );
  }

  function getBucketInfoFromConfig(config) {
    if (!config) return {};
    const { bucket, prefix, path, 'ui.display_path': displayPath } = config;
    let effectivePath;
    let selectedBucket;

    if (path) {
      effectivePath = path;
    } else if (bucket) {
      effectivePath = bucket;

      if (prefix) {
        const separator = effectivePath.endsWith('/') || prefix.startsWith('/') ? '' : '/';
        effectivePath += `${separator}${prefix}`;
      }
    }

    if (effectivePath) {
      const id = effectivePath;
      const lastSlashIndex = id.lastIndexOf('/');
      const name = id.substr(lastSlashIndex + 1);
      const parent = lastSlashIndex > -1 ? id.substr(0, lastSlashIndex) : null;
      const numSlashes = (id.match(/\//g) || []).length;
      const level = numSlashes + 1;

      selectedBucket = {
        id,
        path: effectivePath,
        displayPath: displayPath || effectivePath,
        name,
        parent,
        scanned: false,
        open: false,
        error: null,
        level,
        children: [],
      };
    }

    return {
      selectedBucket,
      effectivePath,
      displayPath,
    };
  }

  return {
    canEditPrefix,
    getBucketInfoFromConfig,
  };
}
